<template>
  <div class="container pt-0" :class="headerStyle">
    <div class="row align-items-center ">
      <div :class="rcLogoBlockStyle">
        <div class="row align-items-center">
          <a class="col-auto" href="https://rcrealty.ru" target="_blank">
            <img class="header-logo" :src="logoHost" alt="rcrealty.ru">
          </a>
          <div class="col">
            <div class="row flex-column">
              <div class="logo-text">
                <b>Центр недвижимости РК</b>
              </div>
              <div class="logo-text">
                Коммерческое предложение
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col mt-xl-0 mt-4">
        <div class="row justify-content-center">
          <div class="row align-items-center header-col-text header-location">
            <i></i>
            <div>
              {{ location }}
            </div>
          </div>
        </div>
      </div>
      <div class="col mt-xl-0 mt-4">
        <div class="row justify-content-center">
          <a class="row align-items-center header-col-text header-link header-phone" :href="'tel:' + phone">
            <i></i>
            <div>{{ phone }}</div>
          </a>
        </div>
      </div>
      <div class="col mt-xl-0 mt-4">
        <div class="row justify-content-center">
          <a class="row align-items-center header-col-text header-link" href="https://rcrealty.ru" target="_blank">
            <i></i>
            <div>rcrealty.ru</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'AppHeader',

  data() {
    return {
      phone: '',
      location: '',
    }
  },
  computed: {
    ...mapGetters(['logoHost', 'isPrint', 'customScript']),
    rcLogoBlockStyle() {
      return {
        'col-12': !this.isPrint,
        'col-xl-6': !this.isPrint,
        'col-6': this.isPrint,
      }
    },
    headerStyle() {
      return {
        header: !this.isPrint,
        'header-print': this.isPrint,
      }
    },
  },

  mounted() {
    if (window.location.href.includes('rcrealtyru')) {
      this.phone = '+79781108638'
      this.location = 'г. Севастополь'
    } else {
      this.phone = '+79786367866'
      this.location = 'г. Симферополь'
    }
    if (this.customScript) {
      try {
        const $head = window.$(document.head)
        const $customScript = window.$(this.customScript)
        $head.append($customScript)
      } catch (e) {
        console.error(e)
      }
    }
  },
}
</script>

<style>
.header {
  margin: 10px 0;
}
.header-print {
  padding: 10px 0;
  height: 10vh;
}

.header-logo {
  width: 70px;
  height: 90px;
}

.logo-text {
  font-size: 30px;
}

.header-link {
  color: #000;
  text-decoration: none;
}

.header-link:hover {
  text-decoration: underline;
}

.header-location i {
  background: url("../assets/img/location.png") no-repeat center;
  width: 19px;
  height: 24px;
  margin-right: 5px;
}

.header-link i {
  background: url("../assets/img/network.png") no-repeat center;
  width: 23px;
  height: 23px;
  margin-right: 5px;
}

.header-phone i {
  background: url("../assets/img/phone.png") no-repeat center;
  width: 23px;
  height: 23px;
  margin-right: 5px;
}

@media (max-width: 576px) {
  .logo-text {
    font-size: 20px;
  }

  .header-logo {
    width: 60px;
    height: 70px;
  }

  .header-col-text {
    font-size: 10px;
  }
}
</style>
